import Vue from 'vue';
import axios from 'axios';

export default {
	login(cuenta) {
		return axios
			.post('/users/login', cuenta, null)
			.then((response) => response.data)
			.catch((error) => error.response.data);
	},
	logout() {
		localStorage.removeItem(Vue.prototype.$SESION);
	}
};
